<template>
  <div class="lesson-list">
    <div class="lesson-item" v-for="(item,index) in list" @click="gotoClass(item)">
      <div class="img-wrapper">
        <img class="img" :src="imgprefix+item.faceimg" alt="img" width="264px" height="176">
      </div>
      <h2 class="title">{{decodeURIComponent(item.lessonname)}}</h2>

      <div class="flex-wrapper">
        <p class="type">{{decodeURIComponent(item.typename)}}</p>
        <p class="enroll">{{$t('m.cou_n_gong')}}{{item.enrollcounts + item.payusercounts+item.viewcounts}}{{$t('m.cou_n_gong2')}}</p>
      </div>
    </div>
  </div>
</template>

<script type="text/ecmascript-6">
  import {saveLocal, loadLocal} from 'common/js/store.js';
  export default{
    props: {
      list: {
        type: Array
      }
    },
    data(){
      return {
        imgprefix: (() => loadLocal('imgprefix', false))(),
      }
    },
    methods:{
      gotoClass(item){
        saveLocal('lessoninfo',item);
        this.$router.push({ name: 'class' })
      }
    },
    watch:{
      list(){
        this.$forceUpdate();
      }
    }
  }
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
  .lesson-list
    .lesson-item
      display: inline-block
      margin: 0 10px 10px 0
      padding: 8px 10px 0
      width: 284px
      height: 270px
      background: #fff
      font-size: 0
      box-sizing border-box
      cursor pointer
      &:hover
        box-shadow: 0 0 15px 2px #e4e4e4
      &:nth-child(4n)
        margin-right: 0
      .img-wrapper
        width: 264px
        height: 176px
        overflow: hidden
        .img
          transition-duration: 300ms
        .img:hover
          transform: scale(1.2, 1.2)
      .title
        margin: 15px 0
        height: 22px
        line-height: 22px
        font-size: 16px
        font-weight: bold
        color: #000000
        overflow: hidden
        text-overflow ellipsis
        white-space nowrap
      .flex-wrapper
        display: flex
        justify-content space-between
        align-items center
        line-height: 16px
        .type, .enroll
          font-size: 12px
          color: #888888

</style>



// WEBPACK FOOTER //
// src/components/lessonlist/LessonList.vue